import styles from "./Divider.module.css";

export interface DividerProps {
  vertical?: boolean;
  costomStyles?: React.CSSProperties;
  role?: "separator" | "presentation";
}
const Divider = ({ vertical = false, costomStyles, role }: DividerProps) => (
  <div
    className={vertical ? styles.verticalDivider : styles.divider}
    style={costomStyles}
    role={role}
  />
);
export default Divider;
